// components/Loading.js
import React from 'react';


const Loading = () => {
  return (
    <div className="loading-container">
      <div className="loading-circle"></div>
    </div>
  );
};

export default Loading;
